var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 201,
    viewBox: "0 0 160 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1930)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650635,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.528 159.651V155.347H25.088V153.811H18.528V150.483H25.328V148.931H16.8V159.651H18.528ZM28.3405 159.651V155.187C28.3405 153.763 28.9005 153.011 30.2605 153.011C31.4445 153.011 31.9245 153.539 31.9245 154.675V155.379H33.6365V154.339C33.6365 152.835 32.8525 151.539 31.0445 151.539C29.4125 151.539 28.5485 152.563 28.3085 153.843H28.1965V151.699H26.6125V159.651H28.3405ZM38.7219 159.811C41.0899 159.811 42.7539 158.643 42.7539 156.947V156.803H41.0259V156.931C41.0259 157.875 40.3379 158.419 38.6739 158.419C36.8339 158.419 36.0819 157.603 36.0179 156.067H42.7699C42.8179 155.827 42.8339 155.603 42.8339 155.315C42.8339 152.899 41.1539 151.539 38.6899 151.539C36.0979 151.539 34.4019 153.203 34.4019 155.683C34.4019 158.339 36.1139 159.811 38.7219 159.811ZM38.6579 152.899C40.3539 152.899 41.2019 153.603 41.2019 155.075V155.107H36.0339C36.1299 153.683 36.8979 152.899 38.6579 152.899ZM48.1281 159.811C50.4961 159.811 52.1601 158.643 52.1601 156.947V156.803H50.4321V156.931C50.4321 157.875 49.7441 158.419 48.0801 158.419C46.2401 158.419 45.4881 157.603 45.4241 156.067H52.1761C52.2241 155.827 52.2401 155.603 52.2401 155.315C52.2401 152.899 50.5601 151.539 48.0961 151.539C45.5041 151.539 43.8081 153.203 43.8081 155.683C43.8081 158.339 45.5201 159.811 48.1281 159.811ZM48.0641 152.899C49.7601 152.899 50.6081 153.603 50.6081 155.075V155.107H45.4401C45.5361 153.683 46.3041 152.899 48.0641 152.899ZM57.9968 162.371V157.411H58.0608C58.3808 158.867 59.5328 159.811 61.3248 159.811C63.8048 159.811 65.1648 158.147 65.1648 155.683C65.1648 153.219 63.7728 151.539 61.3088 151.539C59.4368 151.539 58.3168 152.435 57.9968 153.907H57.8528V151.699H56.2688V162.371H57.9968ZM57.9968 155.811V155.667C57.9968 153.955 58.9888 153.123 60.7648 153.123C62.4288 153.123 63.4368 153.763 63.4368 155.683C63.4368 157.587 62.4448 158.243 60.7328 158.243C59.0368 158.243 57.9968 157.443 57.9968 155.811ZM70.4265 159.811C73.0825 159.811 74.8585 158.131 74.8585 155.683C74.8585 153.203 73.0825 151.539 70.4265 151.539C67.7865 151.539 66.0105 153.203 66.0105 155.683C66.0105 158.131 67.7865 159.811 70.4265 159.811ZM70.4265 158.275C68.5065 158.275 67.7065 157.363 67.7065 155.683C67.7065 153.987 68.5065 153.059 70.4265 153.059C72.3625 153.059 73.1625 153.987 73.1625 155.683C73.1625 157.363 72.3625 158.275 70.4265 158.275ZM77.8405 150.771V148.931H76.1125V150.771H77.8405ZM77.8405 159.651V151.699H76.1125V159.651H77.8405ZM81.1686 159.651V155.715C81.1686 153.987 81.9526 153.091 83.6966 153.091C85.3446 153.091 86.0166 153.843 86.0166 155.331V159.651H87.7446V154.867C87.7446 153.027 86.6566 151.539 84.4486 151.539C82.4326 151.539 81.3766 152.819 81.1366 154.163H81.0246V151.699H79.4406V159.651H81.1686ZM94.5004 159.651V158.099H93.0604C92.0684 158.099 91.6204 157.843 91.6204 156.867V153.139H94.5004V151.699H91.6204V149.955H89.9084V151.699H88.5644V153.139H89.9084V156.963C89.9084 158.899 90.9644 159.651 92.6764 159.651H94.5004ZM102.38 159.811C105.036 159.811 106.812 158.131 106.812 155.683C106.812 153.203 105.036 151.539 102.38 151.539C99.7396 151.539 97.9636 153.203 97.9636 155.683C97.9636 158.131 99.7396 159.811 102.38 159.811ZM102.38 158.275C100.46 158.275 99.6596 157.363 99.6596 155.683C99.6596 153.987 100.46 153.059 102.38 153.059C104.316 153.059 105.116 153.987 105.116 155.683C105.116 157.363 104.316 158.275 102.38 158.275ZM110.402 159.651V153.139H113.25V151.699H110.37C110.274 150.547 110.93 150.211 112.194 150.211H113.25V148.931H112.466C110.21 148.931 108.882 149.955 108.69 151.699H107.474V153.139H108.674V159.651H110.402ZM20.56 179.811C22.8 179.811 24.272 178.931 24.272 177.443C24.272 176.131 23.408 175.491 21.52 175.251L19.68 174.995C18.48 174.835 18.16 174.611 18.16 173.987C18.16 173.235 18.672 172.915 20.128 172.915C21.888 172.915 22.368 173.411 22.368 174.355V174.451H24.08V174.403C24.08 172.515 22.608 171.539 20.176 171.539C17.728 171.539 16.464 172.531 16.464 173.923C16.464 175.251 17.376 175.891 18.88 176.083L21.056 176.371C22.192 176.531 22.576 176.739 22.576 177.395C22.576 178.099 22.112 178.419 20.56 178.419C18.896 178.419 18.272 178.083 18.272 177.043V176.915H16.544V176.963C16.544 178.803 18 179.811 20.56 179.811ZM27.8548 179.811C29.6628 179.811 30.9268 179.011 31.3428 177.667H31.4548V179.651H33.0388V174.819C33.0388 172.915 31.9028 171.539 29.3748 171.539C26.8468 171.539 25.3428 172.899 25.3428 174.707V174.771H27.0548V174.707C27.0548 173.539 27.7748 173.059 29.2468 173.059C30.7668 173.059 31.3428 173.523 31.3428 174.835V175.299L27.7268 175.683C26.1588 175.859 25.1668 176.499 25.1668 177.731C25.1668 179.043 26.2068 179.811 27.8548 179.811ZM26.8948 177.619C26.8948 176.995 27.3268 176.787 28.2228 176.675L31.3428 176.323C31.3428 177.891 30.1268 178.563 28.3188 178.563C27.3268 178.563 26.8948 178.259 26.8948 177.619ZM36.3093 179.651V168.931H34.5813V179.651H36.3093ZM41.9094 179.811C44.2774 179.811 45.9414 178.643 45.9414 176.947V176.803H44.2134V176.931C44.2134 177.875 43.5254 178.419 41.8614 178.419C40.0214 178.419 39.2694 177.603 39.2054 176.067H45.9574C46.0054 175.827 46.0214 175.603 46.0214 175.315C46.0214 172.899 44.3414 171.539 41.8774 171.539C39.2854 171.539 37.5894 173.203 37.5894 175.683C37.5894 178.339 39.3014 179.811 41.9094 179.811ZM41.8454 172.899C43.5414 172.899 44.3894 173.603 44.3894 175.075V175.107H39.2214C39.3174 173.683 40.0854 172.899 41.8454 172.899ZM55.266 179.651V178.099H53.826C52.834 178.099 52.386 177.843 52.386 176.867V173.139H55.266V171.699H52.386V169.955H50.674V171.699H49.33V173.139H50.674V176.963C50.674 178.899 51.73 179.651 53.442 179.651H55.266ZM60.3469 179.811C62.7149 179.811 64.3789 178.643 64.3789 176.947V176.803H62.6509V176.931C62.6509 177.875 61.9629 178.419 60.2989 178.419C58.4589 178.419 57.7069 177.603 57.6429 176.067H64.3949C64.4429 175.827 64.4589 175.603 64.4589 175.315C64.4589 172.899 62.7789 171.539 60.3149 171.539C57.7229 171.539 56.0269 173.203 56.0269 175.683C56.0269 178.339 57.7389 179.811 60.3469 179.811ZM60.2829 172.899C61.9789 172.899 62.8269 173.603 62.8269 175.075V175.107H57.6589C57.7549 173.683 58.5229 172.899 60.2829 172.899ZM67.4811 179.651V175.187C67.4811 173.763 68.0411 173.011 69.4011 173.011C70.5851 173.011 71.0651 173.539 71.0651 174.675V175.379H72.7771V174.339C72.7771 172.835 71.9931 171.539 70.1851 171.539C68.5531 171.539 67.6891 172.563 67.4491 173.843H67.3371V171.699H65.7531V179.651H67.4811ZM75.5905 179.651V175.715C75.5905 173.955 76.1825 173.091 77.8945 173.091C79.4305 173.091 80.0385 173.763 80.0385 175.331V179.651H81.7505V175.715C81.7505 173.955 82.3585 173.091 84.0545 173.091C85.5905 173.091 86.2145 173.763 86.2145 175.331V179.651H87.9265V174.867C87.9265 172.947 86.8865 171.539 84.8225 171.539C82.8065 171.539 81.9105 172.803 81.7025 174.163H81.6065C81.3825 172.643 80.4065 171.539 78.5985 171.539C76.6145 171.539 75.7505 172.771 75.5425 174.099H75.4465V171.699H73.8625V179.651H75.5905ZM91.1999 170.771V168.931H89.4719V170.771H91.1999ZM91.1999 179.651V171.699H89.4719V179.651H91.1999ZM94.528 179.651V175.715C94.528 173.987 95.312 173.091 97.056 173.091C98.704 173.091 99.376 173.843 99.376 175.331V179.651H101.104V174.867C101.104 173.027 100.016 171.539 97.808 171.539C95.792 171.539 94.736 172.819 94.496 174.163H94.384V171.699H92.8V179.651H94.528ZM104.98 179.811C106.788 179.811 108.052 179.011 108.468 177.667H108.58V179.651H110.164V174.819C110.164 172.915 109.028 171.539 106.5 171.539C103.972 171.539 102.468 172.899 102.468 174.707V174.771H104.18V174.707C104.18 173.539 104.9 173.059 106.372 173.059C107.892 173.059 108.468 173.523 108.468 174.835V175.299L104.852 175.683C103.284 175.859 102.292 176.499 102.292 177.731C102.292 179.043 103.332 179.811 104.98 179.811ZM104.02 177.619C104.02 176.995 104.452 176.787 105.348 176.675L108.468 176.323C108.468 177.891 107.252 178.563 105.444 178.563C104.452 178.563 104.02 178.259 104.02 177.619ZM113.434 179.651V168.931H111.706V179.651H113.434Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24.5205,
    y1: 104.983,
    x2: 24.5205,
    y2: -36.5318,
    stroke: "url(#paint0_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5205,
    y1: 104.983,
    x2: 60.5205,
    y2: -36.5318,
    stroke: "url(#paint1_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5205,
    y1: 104.983,
    x2: 96.5205,
    y2: -36.5318,
    stroke: "url(#paint2_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.521,
    y1: 104.983,
    x2: 132.521,
    y2: -36.5318,
    stroke: "url(#paint3_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 3.84424,
    x2: 229.941,
    y2: 3.84422,
    stroke: "url(#paint4_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 62.8442,
    x2: 229.941,
    y2: 62.8442,
    stroke: "url(#paint5_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 32.8442,
    x2: 229.941,
    y2: 32.8442,
    stroke: "url(#paint6_linear_51_1930)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1930)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_51_1930)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_51_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4655 51.014L61.9392 40.1896C61.8264 37.6801 59.834 35.7324 57.4281 35.7324H46.0374C43.6315 35.7324 41.6767 37.6801 41.5263 40.1896L41 51.014C41 51.1638 41 51.2762 41 51.426L41.6015 68.468C41.6767 70.9775 43.6691 73 46.1126 73H57.3905C59.7964 73 61.7888 71.0149 61.9016 68.468L62.5031 51.426C62.4655 51.3136 62.4655 51.1638 62.4655 51.014ZM43.9322 52.7744C43.9322 52.4747 44.1954 52.2126 44.4961 52.2126H47.7667C48.0675 52.2126 48.3306 52.4747 48.3306 52.7744V56.033C48.3306 56.3326 48.0675 56.5948 47.7667 56.5948H44.4961C44.1954 56.5948 43.9322 56.3326 43.9322 56.033V52.7744ZM43.9322 58.093C43.9322 57.7933 44.1954 57.5312 44.4961 57.5312H47.7667C48.0675 57.5312 48.3306 57.7933 48.3306 58.093V61.3516C48.3306 61.6512 48.0675 61.9134 47.7667 61.9134H44.4961C44.1954 61.9134 43.9322 61.6512 43.9322 61.3516V58.093ZM43.9322 65.509V63.6363C43.9322 63.2243 44.2706 62.8872 44.6841 62.8872H53.1801C53.5936 62.8872 53.9319 63.2243 53.9319 63.6363V65.509C53.9319 65.921 53.5936 66.2581 53.1801 66.2581H44.6841C44.2706 66.2581 43.9322 65.921 43.9322 65.509ZM50.0975 57.5312H53.368C53.6688 57.5312 53.9319 57.7933 53.9319 58.093V61.3516C53.9319 61.6512 53.6688 61.9134 53.368 61.9134H50.0975C49.7967 61.9134 49.5336 61.6512 49.5336 61.3516V58.093C49.5336 57.7933 49.7967 57.5312 50.0975 57.5312ZM49.5336 56.033V52.7744C49.5336 52.4747 49.7967 52.2126 50.0975 52.2126H53.368C53.6688 52.2126 53.9319 52.4747 53.9319 52.7744V56.033C53.9319 56.3326 53.6688 56.5948 53.368 56.5948H50.0975C49.7967 56.5948 49.5336 56.3326 49.5336 56.033ZM58.7814 70.0411H45.0224C44.8345 70.0411 44.6465 69.9662 44.4961 69.8164C44.3458 69.6665 44.2706 69.4793 44.2706 69.292C44.2706 68.88 44.6089 68.5429 45.0224 68.5429H58.7814C59.007 68.5429 59.1949 68.6178 59.3077 68.7676C59.4581 68.9174 59.5333 69.1047 59.5333 69.292C59.5333 69.704 59.1949 70.0411 58.7814 70.0411ZM59.5333 65.7338C59.5333 65.996 59.3077 66.2207 59.0446 66.2207H55.6236C55.3605 66.2207 55.1349 65.996 55.1349 65.7338V63.3741C55.1349 63.1119 55.3605 62.8872 55.6236 62.8872H59.0446C59.3077 62.8872 59.5333 63.1119 59.5333 63.3741V65.7338ZM59.5333 61.389C59.5333 61.6886 59.2701 61.9508 58.9694 61.9508H55.6612C55.3605 61.9508 55.0973 61.6886 55.0973 61.389V58.093C55.0973 57.7933 55.3605 57.5312 55.6612 57.5312H58.9318C59.2325 57.5312 59.4957 57.7933 59.4957 58.093V61.389H59.5333ZM59.5333 56.033C59.5333 56.3326 59.2701 56.5948 58.9694 56.5948H55.6612C55.3605 56.5948 55.0973 56.3326 55.0973 56.033V52.7744C55.0973 52.4747 55.3605 52.2126 55.6612 52.2126H58.9318C59.2325 52.2126 59.4957 52.4747 59.4957 52.7744V56.033H59.5333ZM59.5333 48.7293C59.5333 49.0664 59.2325 49.366 58.8942 49.366H44.5713C44.233 49.366 43.9322 49.0664 43.9322 48.7293V40.2645C43.9322 39.9274 44.233 39.6277 44.5713 39.6277H58.8942C59.2325 39.6277 59.5333 39.9274 59.5333 40.2645V48.7293Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8039 32.6236V35.7699H45.6614V32.6236C45.6614 32.0244 46.1501 31.5 46.7892 31.5H56.7137C57.3152 31.5 57.8039 31.9869 57.8039 32.6236Z",
    fill: "#A4D143"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1930)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1930",
    x1: 26.0208,
    y1: 168.078,
    x2: 26.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1930",
    x1: 62.0208,
    y1: 168.078,
    x2: 62.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1930",
    x1: 98.0208,
    y1: 168.078,
    x2: 98.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1930",
    x1: 134.021,
    y1: 168.078,
    x2: 134.021,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1930",
    x1: 240.724,
    y1: 4.34424,
    x2: -37.6865,
    y2: 4.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1930",
    x1: 240.724,
    y1: 63.3442,
    x2: -37.6865,
    y2: 63.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1930",
    x1: 240.724,
    y1: 33.3442,
    x2: -37.6865,
    y2: 33.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1930",
    x1: 52,
    y1: 16.5,
    x2: 54.1764,
    y2: 112.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FBAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703509,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1930",
    x1: 52,
    y1: 16.5,
    x2: 52,
    y2: 88.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFF981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650635,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_51_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(31 31.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_51_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4655,
    height: 41.5,
    fill: "white",
    transform: "translate(41 31.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness2);
export default __webpack_public_path__ + "static/media/business2.6e93f36f36c10ea8522333cdb938afaf.svg";
export { ForwardRef as ReactComponent };